import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { fontFamilies } from "../../constants";
import { ReactComponent as AlarmOutlineIcon } from "../../assets/img/alarm-outline.svg";
import { ReactComponent as InfoCircleIcon } from "../../assets/img/info-circle.svg";
import LightTooltip from "../LightTooltip";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: 4,
    position: "relative",
    background:
      "linear-gradient(90deg, rgba(131, 99, 240, 0.4) 0%, rgba(131, 99, 240, 0) 100%)",
    borderRadius: 12,
    color: "#fff",
    height: 54,
  },
  activateText: {
    display: "flex",
    // alignItems: "center",
    gap: 4,
    fontSize: 10,
    fontFamily: fontFamilies[400],
    color: "rgba(255, 255, 255, 0.47)",
    textTransform: "uppercase",
  },
  daysWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    gap: 5,
  },
  daysTextWrapper: { fontSize: 14 },
  in: { color: "rgba(137, 138, 141, 1)" },
  tooltipHideWrapper: {
    position: "absolute",
    top: 4,
    right: 4,
  },
  mainText: {
    lineHeight: 1,
    paddingTop: 1,
  },
}));

const MenuBrandActivation = ({ activateDate, isHide }) => {
  const classes = useStyles();

  const differenceInDays = useMemo(() => {
    const differenceInTime =
      new Date(activateDate).getTime() - new Date().getTime();
    return Math.round(differenceInTime / (1000 * 3600 * 24));
  }, [activateDate]);

  return (
    <div className={classes.root}>
      {!isHide && (
        <div className={classes.activateText}>
          <div className={classes.mainText}>YOUR ACCOUNT WILL BE ACTIVATED</div>
        </div>
      )}
      <div className={classes.daysWrapper}>
        <AlarmOutlineIcon
          fill="#8363F0"
          width={isHide ? 20 : 17}
          height={isHide ? 20.75 : 18}
        />
        {!isHide && (
          <>
            <div className={classes.daysTextWrapper}>
              <span className={classes.in}>In</span>{" "}
              <span>{differenceInDays} days</span>
            </div>
            <LightTooltip
              title="If your brand goes live earlier than expected, we can proceed to launch"
              arrow
            >
              <InfoCircleIcon width={18} height={18} />
            </LightTooltip>
          </>
        )}
      </div>
    </div>
  );
};

export default MenuBrandActivation;
